import React, { useState } from "react";
import useContactForm from "../hooks/useContactForm";
import InputField from "../UI/InputField";
import TextAreaField from "../UI/TextAreaField";
import styles from "../../../pages/styles";

const ContactUs = ({ rounded = false }) => {
  const { formData, handleChange, handleSubmit } = useContactForm();

  return (
    <div
      id="contactus"
      className={`${
        rounded && `lg:rounded-t-3xl `
      } flex flex-col bg-darkprimary py-8 md:py-10 px-4 md:px-20 relative`}
    >
      <div className="max-w-3xl mx-auto w-full">
        <div className="bg-darkprimary/50 backdrop-blur-sm rounded-2xl shadow-xl border-2 border-white/20 p-6 md:p-8">
        {!formData.submitted ? (
          <form onSubmit={handleSubmit}>
            <h2 className={`${styles.biggerheadingwhite} mb-3 md:mb-4 text-center`}>
              Contact Us
            </h2>
            <div className="grid grid-cols-2 gap-2 items-end">
              <InputField
                title="Parent/Guardian Name"
                name="parentname"
                value={formData.parentname}
                onChange={handleChange}
                placeholder="Jane Doe"
                dark={true}
              />
              <InputField
                title="Phone Number"
                name="phone"
                type="number"
                value={formData.phone}
                onChange={handleChange}
                placeholder="(123) 456-7896"
                dark={true}
              />
              <InputField
                title="Student Name"
                name="studentname"
                value={formData.studentname}
                onChange={handleChange}
                placeholder="Jack Doe"
                dark={true}
              />
              <InputField
                title="Email Address"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="youremail@mail.com"
                dark={true}
              />
              <div className="mb-4">
                <p className={`${styles.paragraphwhite}`}>
                  Preferred Contact Method
                </p>
                <select
                  value={formData.contactpreference}
                  name="contactpreference"
                  onChange={handleChange}
                  className="p-2 px-4 rounded-xl w-full bg-white/10 backdrop-blur-sm border-2 border-white/30 text-white focus:border-orangeprimary focus:outline-none"
                  required
                >
                  <option value="" disabled defaultValue className="bg-darkprimary text-white">
                    Please Choose
                  </option>
                  <option value="email" className="bg-darkprimary text-white">Email</option>
                  <option value="phone" className="bg-darkprimary text-white">Phone</option>
                </select>
              </div>
              <div className="mb-4">
                <p className={`${styles.paragraphwhite}`}>
                  How Did You Hear About Us?
                </p>
                <select
                  value={formData.referralSource}
                  name="referralSource"
                  onChange={handleChange}
                  className="p-2 px-4 rounded-xl w-full bg-white/10 backdrop-blur-sm border-2 border-white/30 text-white focus:border-orangeprimary focus:outline-none"
                  required
                >
                  <option value="" disabled className="bg-darkprimary text-white">
                    Please Choose
                  </option>
                  <option value="friend" className="bg-darkprimary text-white">Friend</option>
                  <option value="internet" className="bg-darkprimary text-white">Internet Search</option>
                  <option value="socialmedia" className="bg-darkprimary text-white">Facebook or Social Media</option>
                  <option value="casemanager" className="bg-darkprimary text-white">Case Manager</option>
                  <option value="supportcoordinator" className="bg-darkprimary text-white">
                    Support Coordinator
                  </option>
                  <option value="other" className="bg-darkprimary text-white">Other</option>
                </select>
              </div>
            </div>
            {formData.referralSource === "other" && (
              <div className="mb-4">
                <InputField
                  title="What Introduced You to Us?"
                  name="referralOther"
                  value={formData.referralOther}
                  onChange={handleChange}
                  placeholder="I discovered you guys on the dinosaur channel"
                  dark={true}
                />
              </div>
            )}
            <TextAreaField
              title="Notes (Optional)"
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="You can request free trial here or any other questions"
              dark={true}
            />
            <input
              type="submit"
              value="Send Message"
              className="mt-5 rounded-full bg-pinkprimary hover:bg-orangeprimary px-6 py-3 text-white font-semibold w-full transition-colors"
            />
          </form>
        ) : (
          <div className="flex flex-col items-center text-center">
            <h2 className={`${styles.biggerheadingwhite} mb-4`}>
              Thank you for contacting us!
            </h2>
            <p className={`${styles.paragraphwhite} mb-6`}>
              We'll be back with you shortly.
            </p>
            <a href="/#classes">
              <button className="bg-pinkprimary text-white hover:bg-orangeprimary px-6 py-3 rounded-full font-semibold transition-colors">
                See Class Options
              </button>
            </a>
          </div>
        )}
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
